import { SalesmanActionTypes } from './salesman.types'
export const setCurrentSalesman = salesman => ({
    type: SalesmanActionTypes.SET_CURRENT_SALESMAN,
    payload: salesman
})